import React from "react";

interface Props {
  count: number;
  onClear: () => void;
}

/** Shared banner for the Portfolio Map working set — shown (and filters the
 * list) on whichever tab the user was sent to via a single-account
 * "See all portfolio actions →" or the multi-select comparison panel's
 * "Review actions/priorities/Portfolio Goals →" links. */
const WorkingSetBanner: React.FC<Props> = ({ count, onClear }) => (
  <div className="mb-3 flex items-center justify-between rounded-md border border-purple-200 bg-purple-50 px-3 py-1.5 text-[12px]">
    <span className="font-semibold text-purple-800">
      Comparing {count} account{count === 1 ? "" : "s"} from Portfolio Map
    </span>
    <button
      type="button"
      onClick={onClear}
      className="font-semibold text-purple-700 hover:underline"
    >
      Clear
    </button>
  </div>
);

export default WorkingSetBanner;
